// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_4f720283bf--wrapper--L09ZY","icon":"_4f720283bf--icon--nA82L","message":"_4f720283bf--message--_j2En"};